import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { useScheduledGoogleEnrichmentContext } from '~/features/content-enrichment/adapters/scheduled-google-enrichment-adapter';
import { EnrichmentCtx } from '~/features/content-enrichment/context/enrichment-context';

const ContentEnrichmentLayout = lazy(
  () => import('~/features/content-enrichment/pages/content-enrichment-layout'),
);

/**
 * Provider wrapper that builds the Google Ads scheduled-enrichment context and
 * injects it into the shared funnel tree. Keeps the route file responsible
 * only for wiring — all Google-specific logic lives in the adapter hook.
 */
function GoogleAdsEnrichmentProvider() {
  const ctx = useScheduledGoogleEnrichmentContext();
  return (
    <EnrichmentCtx.Provider value={ctx}>
      <ContentEnrichmentLayout />
    </EnrichmentCtx.Provider>
  );
}

/** Layout route for the Google Ads content-enrichment funnel. URL: `/enrichments/google/content-enrichment/...`. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <GoogleAdsEnrichmentProvider />
    </Suspense>
  ),
});
